module.exports = __webpack_public_path__ + "static/favicon-1c84f45a01393bd8bc0dbc0f997a2eb8.ico";